import { provideObject } from '@/lib/AuthenticatorPlugin.ts'

export default (routeName: string) => {
  const auth0Object = provideObject()
  window.localStorage.setItem('postSignInRouteName', routeName)
  auth0Object.auth0.createAccount()
}
